define(function(require,exports,module) {
    var lazyload = require('../../unit/lazyload/lazyload');
    var tab = {
        f: [],
        //selfObj: 自定义对象，允许在参数中传一个自定义对象
        tapEvent: function(className, startFn, moveFn, endFn, selfObj) {
            var self = this;
            self.f.lastOffsetX = 0;

            if(typeof(jQuery) != "undefined") {
                jQuery.noConflict();
            }

            $(className).on("touchstart", function(e) {
                if(selfObj) {
                    self.f.lastOffsetX = selfObj.getWrapperTranslate('x');
                }

                if($.isFunction(startFn)) {
                    startFn(e, self);
                } else {
                    self.defaultCallback_start(e, self);
                }
            }).on("touchmove", function(e) {
                if($.isFunction(moveFn)) {
                    moveFn(e, self);
                } else {
                    self.defaultCallback_move(e, self);
                }

            }).on("touchend", function(e) {
                var _this = $(this);
                if($.isFunction(endFn)) {
                    endFn(e, _this, self, selfObj);
                } else {
                    self.defaultCallback_end(e, _this, self, selfObj);
                }
            });
        },
        justTap: function() {
            var self = this;
            self.tapEvent(".tabs ul li", "", "", self.normal_tab);
        },
        normal_tab: function(e, _this, self) {
            var self = self;

            if(self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {
            } else {
                _this.parent().children().removeClass("curr");
                _this.addClass("curr");

                var idx = _this.attr("tab-idx");
                var tabCnts = _this.parent().parent().children(".tabCnt")
                tabCnts.addClass("hide");

                tabCnts.each(function() {
                    if($(this).attr("cnt-idx") == idx) {
                        $(this).removeClass("hide");
                        return false;
                    }
                });

                lazyload.fn.init();
            }
        },
        defaultCallback_start: function(e, self) {
            var self = self;

            self.f.startX = e.touches[0].clientX;
            self.f.endX = e.touches[0].clientX;
            self.f.prevX = self.f.startX;
            self.f.prevY = e.touches[0].clientY;
            self.f.directionX = "";
            self.f.directionY = "";
        },
        defaultCallback_move: function(e, self) {
            var self = self;

            if(e.touches.length > 0) {
                self.f.directionX = e.touches[0].clientX - self.f.prevX > 0 ? "right" : "left";
                self.f.directionY = e.touches[0].clientY - self.f.prevY > 0 ? "bottom" : "top";
            } else {
                self.f.directionX = "";
                self.f.directionY = "";
            }
        },
        defaultCallback_end: function(e, _this, self, selfObj) {
            var self = self;

            if(self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {
            } else {
                _this.parent().children().removeClass("curr");
                _this.addClass("curr");

                var idx = _this.attr("tab-idx");
                var tabCnts = _this.parent().parent().parent().children(".tabCnt");
                tabCnts.addClass("hide");

                tabCnts.each(function() {
                    if($(this).attr("cnt-idx") == idx) {
                        $(this).removeClass("hide");
                        return false;
                    }
                });

                self.setPosition(_this, self, selfObj);
                lazyload.fn.init();
            }
        },
        autoSelected: function(_this, selfObj) {
            var self = this;

            _this.parent().children().removeClass("curr");
            _this.addClass("curr");

            var wrapper = _this.parent().parent();
            var dlObj = wrapper.find("dl");
            var ddObj = wrapper.find("dd");

            var ddOffsetX = _this.offset().left - $("body").offset().left;
            var middle = wrapper.width()/2 - _this.width()/2;

            var totalLength = 0;
            ddObj.each(function() {
                var ddWidth = _this[0].style.width;
                ddWidth = parseFloat(ddWidth.substring(0, ddWidth.length-2));

                totalLength = totalLength + ddWidth;
            });

            var offsetLength = totalLength - wrapper.width();

            if(offsetLength <= 0) {
                return false;
            }

            var lastOffsetX = self.f.lastOffsetX || 0;

            var moveX = middle - ddOffsetX + lastOffsetX;

            if(moveX < -offsetLength) {
                moveX = -offsetLength;
            } else if(moveX > 0) {
                moveX = 0
            }

            self.f.lastOffsetX = moveX;

            dlObj.css({
                "transition-duration": "300ms",
                "-webkit-transition-duration": "300ms",
                "-moz-transition-duration": "300ms",
                "-o-transition-duration": "300ms"
            });

            selfObj.setWrapperTranslate(moveX);
        },
        setPosition: function(_this, self, selfObj) {
            var wrapper = _this.parent().parent();
            var dlObj = wrapper.find("dl");
            var ddObj = wrapper.find("dd");

            var ddOffsetX = _this.offset().left - $("body").offset().left;
            var middle = wrapper.width()/2 - _this.width()/2;

            var totalLength = 0;
            ddObj.each(function() {
                var ddWidth = _this[0].style.width;
                ddWidth = parseFloat(ddWidth.substring(0, ddWidth.length-2));

                totalLength = totalLength + ddWidth;
            });

            var offsetLength = totalLength - wrapper.width();

            if(offsetLength <= 0) {
                return false;
            }

            var moveX = middle - ddOffsetX + self.f.lastOffsetX;

            if(moveX < -offsetLength) {
                moveX = -offsetLength;
            } else if(moveX > 0) {
                moveX = 0
            }

            self.f.lastOffsetX = moveX;

            dlObj.css({
                "transition-duration": "300ms",
                "-webkit-transition-duration": "300ms",
                "-moz-transition-duration": "300ms",
                "-o-transition-duration": "300ms"
            });

            selfObj.setWrapperTranslate(moveX);
        }
    };

    module.exports = tab;
});



// WEBPACK FOOTER //
// ./src/js/model/tabModel/tabModel.js